var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "margin-top" },
    [
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              conteudo: _vm.conteudoModal,
              isVTN: false
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _c("validation-observer", { ref: "validation", attrs: { tag: "form" } }),
      _vm._l(_vm.dadosCadastros, function(cadastro) {
        return [
          _vm.dadosExiste
            ? _c(
                "el-card",
                { staticClass: "card-collapse", attrs: { shadow: "hover" } },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(_vm._s(cadastro.label))
                  ]),
                  _c(
                    "el-table",
                    {
                      staticClass: "margin-bottom",
                      attrs: { data: cadastro.data }
                    },
                    [
                      !cadastro.data
                        ? _c("template", { slot: "empty" }, [
                            _vm._v("Não há registros.")
                          ])
                        : _c("template", { slot: "empty" }, [
                            _vm._v("Não há anexos para serem validados.")
                          ]),
                      _vm._l(cadastro.headers, function(header, indexHeader) {
                        return [
                          cadastro.headers[indexHeader].acao == null
                            ? _c("el-table-column", {
                                attrs: {
                                  label: cadastro.headers[indexHeader].titulo,
                                  prop:
                                    cadastro.headers[indexHeader].propriedade,
                                  sortable: cadastro.headers[indexHeader].ordem
                                }
                              })
                            : _vm._e(),
                          cadastro.headers[indexHeader].propriedade ==
                          "visualizar"
                            ? _c("el-table-column", {
                                attrs: { width: 250 },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "flex-end" },
                                            [
                                              _vm.showValidacaoDocumentos
                                                ? _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "el-radio-group",
                                                                {
                                                                  staticClass:
                                                                    "input padding",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.setValidacaoDocumento(
                                                                        cadastro
                                                                      )
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .isValido,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "isValido",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "scope.row.isValido"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-radio",
                                                                    {
                                                                      attrs: {
                                                                        label: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Válido"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "el-radio",
                                                                    {
                                                                      attrs: {
                                                                        label: false
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Inválido"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "button" },
                                                [
                                                  _vm.showVisualizarDocumento(
                                                    scope.row
                                                  )
                                                    ? _c("app-action-button", {
                                                        attrs: {
                                                          icone: "eye",
                                                          text: "Visualizar",
                                                          fontSize: "18"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.abrirPdf(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm.showBaixarDocumento(
                                                    scope.row
                                                  )
                                                    ? _c("app-action-button", {
                                                        attrs: {
                                                          icone: "download",
                                                          cor: "#666666",
                                                          text:
                                                            "Baixar Documento",
                                                          posicaoTooltip: "left"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.download(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              scope.row.isValido &&
                                              _vm.showDocumentosValidos
                                                ? _c(
                                                    "div",
                                                    { staticClass: "valido" },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "check",
                                                          size: "lg"
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v("  Válido")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : scope.row.isValido ===
                                                    false &&
                                                  _vm.showDocumentosValidos
                                                ? _c(
                                                    "div",
                                                    { staticClass: "invalido" },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "times",
                                                          size: "lg"
                                                        }
                                                      }),
                                                      _c("span", [
                                                        _vm._v("  Inválido")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cf0ab02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf0ab02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppVisualizarDocumentos.vue
// module id = null
// module chunks = 